import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { isTexas } from 'site-modules/shared/utils/inventory-utils/is-texas';

const ABOVE_MARKET = 'Above_market';
export const NO_RATING = 'NO_RATING';
const GREAT = 'Great';
const GOOD = 'Good';
const FAIR = 'Fair';
export const NO_DEAL_RATINGS = [
  'Title_issues_reported',
  'Missing_data',
  'Not_enough_sample',
  'Title_issues_reported',
  'Low_data_quality',
  null,
];

export const USED_HEADERS_MAP = {
  [GREAT]: 'This is a great deal, the dealer’s price is well below what we’d expect!',
  [GOOD]: 'This is a good deal, the dealer’s price is below what we’d expect!',
  [FAIR]: 'This is not a bad deal, but there may be room for negotiation.',
  [ABOVE_MARKET]: 'This price seems a bit above market. Consider negotiating for a better deal.',
  [NO_RATING]: 'Choose a payment that works for you.',
};

export const BAD_DEALS_MSG_MAP = {
  [ABOVE_MARKET]: (price, stateCode) => {
    let title = '';
    if (!!price && !isTexas(stateCode)) title = `Price is ${formatPriceString(Math.abs(price))} above market. `;
    title = `${title}Consider negotiating for a better deal.`;
    return title;
  },
  [NO_RATING]: () => 'We’re unable to accurately rate this vehicle’s price at this time.',
};

export function getDealRating(dealType) {
  return NO_DEAL_RATINGS.includes(dealType) ? NO_RATING : dealType;
}
